import React, { useState, useEffect } from "react";
import EventosCard from "../../../components/Authenticated/Eventos/EventosCard";
import HeaderLogado from '../../../components/common/Authenticated/Header/HeaderLogado';
import DetalhesEvento from "../../../components/Authenticated/Eventos/DetalhesEvento";
import BottomMenu from "../../../components/common/Authenticated/Menu/Menu";
import api from "../../../services/api"; // sua instância axios
import consts from "../../../consts.js"; // para pegar o salaoId
import LoadingComponent from "../../../components/common/LoadingComponent.js";

function Eventos() {
  const [eventos, setEventos] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventos = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const salaoId = consts.salaoId;

        const { data } = await api.get(`evento/salao/${salaoId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!data.error) {
          setEventos(data.eventos);
        } else {
          console.error("Erro ao buscar eventos:", data.message);
        }
      } catch (err) {
        console.error("Erro ao buscar eventos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEventos();
  }, []);

  return (
    <>
      <HeaderLogado/>
      <div className="min-h-screen bg-gray-100 p-6 pb-20">
        {loading ? (
          <LoadingComponent/>
        ) : !eventoSelecionado ? (
          eventos.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {eventos.map((evento) => (
                <EventosCard 
                  key={evento._id} 
                  evento={evento} 
                  onSelectEvento={() => setEventoSelecionado(evento)} 
                />
              ))}
            </div>
          ) : (
            <div className="flex justify-center items-center h-48 text-gray-600">
              Nenhum evento disponível.
            </div>
          )
        ) : (
          <DetalhesEvento 
            evento={eventoSelecionado} 
            onBack={() => setEventoSelecionado(null)} 
          />
        )}
      </div>
      <BottomMenu/>
    </>
  );
}

export default Eventos;
